import React from 'react';

import { TestType } from '@qality/common-model/src/TestType';
import { useTestTypesContext } from '@qality/common-pages';
import {
  IssueTestTypeDetails,
  useIssueTestTypeContext,
} from '@qality/common-pages/src/IssueView/IssueTestTypeProvider/IssueTestTypeProvider';
import { StorageOfUniqueServices } from '@qality/common-service';
import { DEFAULT_TEST_TYPE } from '@qality/common-utils/src/TestType.const';

import { IssueTestType as IssueTestTypeComponent } from '../molecules/IssueTestType';
import { TestTypePopupSelectProvider } from '../select/TestTypePopupSelect';

type Props = {
  testCaseId: number;
  canEdit: boolean;
};

export default function TestCaseBoxTestType({
  testCaseId,
  canEdit,
}: Props): JSX.Element {
  const { getTestType } = useTestTypesContext();

  const { getIssueTestTypeDetails, updateIssueTestType } =
    useIssueTestTypeContext();

  const issueTestType: IssueTestTypeDetails =
    getIssueTestTypeDetails(testCaseId);

  const testTypeId: number = issueTestType?.issueTestType?.testTypeId;

  const IS_ADVANCED = StorageOfUniqueServices.get('LicenseService').isAdvanced;

  // - issueTestType?.isLoading - checks if type for specific issue is loading
  // - !getTestType(testTypeId) - checks if test type provider fetched data
  const getIsLoading = () => {
    return issueTestType?.isLoading || !getTestType(testTypeId);
  };

  return (
    <TestTypePopupSelectProvider
      selectedTestType={getTestType(issueTestType?.issueTestType?.testTypeId)}
      setSelectedTestType={(testType: TestType) => {
        if (testType.id !== testTypeId) {
          const updatedIssueTestType = {
            testCaseId: testCaseId,
            testTypeId: testType.id,
          };
          updateIssueTestType(updatedIssueTestType);
        }
      }}
    >
      <IssueTestTypeComponent
        testType={IS_ADVANCED ? getTestType(testTypeId) : DEFAULT_TEST_TYPE}
        isReadOnly={!canEdit || !IS_ADVANCED}
        isLoading={IS_ADVANCED ? getIsLoading() : false}
        loadingType='spinner'
      />
    </TestTypePopupSelectProvider>
  );
}
